import React, {useState} from 'react';
import styled from 'styled-components';
import DelegateItem from './DelegateItem';
import {SVGICONS} from '@ey/icons';
import {labels, currentResource} from '../../../../../common/utils/utils';
import ConfirmationModal from '../../../../../common/components/ConfirmationModal/confirmationModal';
import {MotifTooltip} from '@ey-xd/motif-react';

const ViewDelegate = (props) => {
	const {activeTab, users, removeDelegate, noDelegationMessage} = props;
	const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
	const [userToRemove, setUserToRemove] = useState(false);
	const [hideTooltip, setHideTooltip] = useState(false);

	const onRemoveClick = (removeUser) => {
		setUserToRemove(removeUser);
		setShowDeleteConfirmation(true);
	};

	return (
		<StyledSection {...props}>
			{users.length > 0 ? (
				users.map((user, index) => {
					return (
						<section className="delegate-item" key={user.userId}>
							<DelegateItem
								activeTab={activeTab}
								user={user}
								className={
									index + 1 !== users.length ? 'bottom-border-zero' : ''
								}
							/>
							{activeTab === '1' ? (
								<MotifTooltip
									id={`remove-${user.userId}`}
									trigger={
										<span
											onClick={() => {
												setHideTooltip(true);
												onRemoveClick(user);
											}}
											className="remove-delegate-button"
										>
											<SVGICONS
												styleName="medium"
												hoverText={labels.remove}
												name="close"
												alt="Remove"
											/>
										</span>
									}
									placement="right"
									variant="default"
									contentClassName="hideTooltipClose"
									hide={hideTooltip}
								>
									{labels.remove}
								</MotifTooltip>
							) : (
								''
							)}
						</section>
					);
				})
			) : (
				<section className="no-delegation-message">
					{noDelegationMessage}
				</section>
			)}
			<ConfirmationModal
				show={showDeleteConfirmation}
				showButtons
				title={labels.removeDelegateTitle}
				description={labels.removeDelegateMessgae}
				bodyText={`${labels.delegate}:`}
				bodyTextValue={`${userToRemove.firstName} ${userToRemove.lastName}`}
				confirmBtnTitle={labels.remove}
				cancelBtnTitle={labels.cancel}
				onConfirmClick={() => {
					removeDelegate(userToRemove);
					setShowDeleteConfirmation(false);
					setHideTooltip(false);
				}}
				onHide={() => {
					setShowDeleteConfirmation(false);
					setHideTooltip(false);
				}}
				closeTitle={currentResource.common.close}
				modalsize="small"
			/>
		</StyledSection>
	);
};

export default ViewDelegate;

const StyledSection = styled.section`
	display: flex;
	flex-flow: column;
	height: 100%;
	width: ${(props) =>
		props.activeTab === '1' ? 'calc(100% - 17rem)' : 'calc(100% - 20rem)'};
	margin-top: 1rem;
	margin-bottom: 1rem;
	.no-delegation-message {
		font-size: 1.4rem;
		color: ${(props) => props.theme.color[`grey400`]};
	}
	.delegate-item {
		flex-flow: row;
		display: flex;
	}
	.bottom-border-zero {
		border-bottom: 0;
	}
	.remove-delegate-button {
		margin: 0 0 0 1rem;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		svg {
			fill: ${(props) => props.theme.color[`black`]};
		}
	}
	.motif-tooltip-wrapper {
		display: flex;
	}
`;
